module.exports = __webpack_public_path__ + "static/media/cursuri-digitale-logo2-07.68abec57.jpg";